import { Component, EventEmitter, Signal, signal, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Option } from '@cumlaude/shared-utils';
import { IconComponent } from '@cumlaude/shared-components-icons';

export interface SingleSelectDropdownData<T> {
	opties: Signal<Option<T>[]>;
	selectedOptie?: Option<T>;
	showEmpty: string;
	showSearchInput: boolean;
	label?: string;
}

@Component({
	selector: 'app-single-select-dropdown-dialog',
	templateUrl: './single-select-dropdown-dialog.component.html',
	styleUrls: ['./single-select-dropdown-dialog.component.scss'],
	imports: [IconComponent],
})
export class SingleSelectDropdownDialogComponent<T> {
	dialogRef = inject<DialogRef<Option<T>>>(DialogRef);
	protected data = inject<SingleSelectDropdownData<T>>(DIALOG_DATA);

	searchInput = signal('');

	onSearchInput = new EventEmitter<string>();

	search($event: string) {
		this.onSearchInput.next($event);
	}

	isSelected(optie: Option<T>) {
		return optie.value === this.data.selectedOptie?.value;
	}

	clickOptie(clickedOptie: Option<T>) {
		this.dialogRef.close(clickedOptie);
	}
}
